<template>
    <v-content class="pa-12">
        <v-layout mt-6>
            <v-flex shrink style="font-weight: bold;">
                <span>กรองประเภท</span>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex style="color: #3E7662;">
                <v-radio-group hide-details v-model="filterType">
                    <v-layout class="my-1">
                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countRF12 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF12 > 0">{{
                                        countRF12
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('1')"
                                        :class="checkRadio1 ? 'radio-checked' : ''" color="#3E7662"
                                        label="แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย (RF 12_2563)" value="1" />

                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countRF03 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF03 > 0">{{
                                        countRF03
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('4')"
                                        :class="checkRadio4 ? 'radio-checked' : ''" color="#3E7662"
                                        label="แบบรายงานความก้าวหน้าของการวิจัย/ขอต่ออายุโครงการ (RF 03_2563)" value="4" />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                    <v-layout class="my-1">
                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countRF04_2 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_2 > 0">{{
                                        countRF04_2
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('8')"
                                        :class="checkRadio8 ? 'radio-checked' : ''" color="#3E7662"
                                        label="แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา (RF 04_1_2563)"
                                        value="8" />

                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countRF06 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;" v-if="countRF06 > 0">{{ countRF06
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('5')"
                                        :class="checkRadio5 ? 'radio-checked' : ''" color="#3E7662"
                                        label="แบบรายงานแจ้งปิด/สรุปผลการวิจัย (RF 06_2563)" value="5" />

                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                    <v-layout class="my-1">
                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countRF04_1 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_1 > 0">{{
                                        countRF04_1
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('2')"
                                        :class="checkRadio2 ? 'radio-checked' : ''" color="#3E7662"
                                        label="แบบรายงานเหตุการณ์ไม่พึงประสงค์ (SAE) (RF 04_2_2563)" value="2" />

                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countRF07 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF07 > 0">{{
                                        countRF07
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('7')"
                                        :class="checkRadio7 ? 'radio-checked' : ''" color="#3E7662"
                                        label="แบบรายงานการยุติโครงการวิจัยก่อนกําหนด (RF 07_2563)" value="7" />

                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                    <v-layout class="my-1">
                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countRF05 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF05 > 0">{{
                                        countRF05
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('3')"
                                        :class="checkRadio3 ? 'radio-checked' : ''" color="#3E7662"
                                        label="แบบรายงานการไม่ปฏิบัติตามข้อกำหนด (RF 05_2563)" value="3" />
                                    <!--                             label="รายงานการเบี่ยงเบนโครงร่างวิจัย (Deviation Report)"-->
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countCorres > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countCorres > 0">{{
                                        countCorres
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('6')"
                                        :class="checkRadio6 ? 'radio-checked' : ''" color="#3E7662"
                                        label="เอกสารและจดหมายแจ้งเกี่ยวกับงานวิจัย (Correspondence Report)" value="6" />
                                    <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-1">
                        <v-flex class="xs6 py-1"></v-flex>
                        <v-flex class="xs6 py-1">
                            <v-layout>
                                <!-- <v-flex class="xs1 align-center d-flex justify-end">
                                    <v-icon v-if="countSusar > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countSusar > 0">{{
                                        countSusar
                                    }}</span>
                                </v-flex> -->
                                <v-flex xs11>
                                    <v-radio class="ml-3" @click.native="checkRadio('9')"
                                        :class="checkRadio9 ? 'radio-checked' : ''" color="#3E7662"
                                        label="แบบรายงานเหตุการณ์ไม่พึ่งประสงค์นอกสถาบัน SUSAR / DMC / DSMB" value="9" />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-radio-group>
            </v-flex>
        </v-layout>
        <v-layout mt-4>
            <v-flex>
                <form-table :headers="headers" :items="list" onViewData></form-table>
            </v-flex>
        </v-layout>
        <v-layout mt-12>
            <v-flex>
                <v-pagination color="#3E7662" :length="paginate.last_page" :total-visible="9"
                    v-model="paginate.current_page"></v-pagination>
            </v-flex>
        </v-layout>
        <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-pageAndLine="fullpageAndLine">
        </loading>
    </v-content>
</template>

<script>
import FormTable from "../../components/table/FormTable";
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    name: "FormResearch",
    components: {
        FormTable,
        Loading
    },
    computed: {
        ...mapState({
            user: (state) => state.Auth.user,
        }),
    },
    data: () => ({
        fullpageAndLine: true,
        filterType: "1",
        checkRadio1: false,
        checkRadio2: false,
        checkRadio3: false,
        checkRadio4: false,
        checkRadio5: false,
        checkRadio6: false,
        checkRadio7: false,
        checkRadio8: false,
        checkRadio9: false,
        checkRFDialog: false,
        viewFileDialog: false,
        isLoading: false,
        isLoadingTable: false,
        fullPage: true,
        paginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1,
        },
        headers: [
            {
                text: "เอกสาร",
                value: "nameResearch",
                align: "center",
                sortable: false,
            },
            {
                text: "ครั้งที่",
                value: "groupID",
                align: "center",
                sortable: false,
            },
            {
                text: "action at",
                value: "actionat",
                align: "center",
                sortable: false,
            }

        ],
        list: []
    }),
    async created() {
        console.log("filter",this.$route.query.filter);
        this.filterType = this.$route.query.filter;
        this.checkRadio(this.filterType);
        await this.getDocumentResearch(1);
    },
    methods: {
        getDocumentResearch(page) {
            this.isLoading = true;
            this.list = [];
            let data = {
                page: page,
                filter: this.filterType,
                id: this.$route.query.id,
            };
            this.$store.dispatch("FormRF/getDocumentResearch", data).then((res) => {
                let i = 1;
                res.data.forEach((data) => {
                    this.list.push({
                        id: data.id,
                        rfID: data.id,
                        idReport: data.researchID ? data.researchID : "-",
                        userID: this.$route.query.id,
                        nameResearch: data.researchName,
                        groupID: data.group_id + 1,
                        actionat: data.updated_at,
                        onView: 16,
                        filterType: this.filterType,
                        evaluation:
                            this.filterType == 1
                                ? "FormRO05"
                                : "" || this.filterType == 2
                                    ? "FormRO07"
                                    : "" || this.filterType == 3
                                        ? "FormRO08"
                                        : "" || this.filterType == 4
                                            ? "FormRO06"
                                            : "" || this.filterType == 5
                                                ? "FormRO09"
                                                : "" || this.filterType == 6
                                                    ? "FormRO19"
                                                    : "" || this.filterType == 7
                                                        ? "FormRO10"
                                                        : "" || this.filterType == 8
                                                            ? "FormRO07"
                                                            : "" || this.filterType == 9
                                                                ? "FormRFSusar"
                                                                : "",
                        rfType:
                            this.filterType == 1
                                ? "Amendment"
                                : "" || this.filterType == 2
                                    ? "AdverseEvent"
                                    : "" || this.filterType == 3
                                        ? "Deviation"
                                        : "" || this.filterType == 4
                                            ? "Progress"
                                            : "" || this.filterType == 5
                                                ? "Final"
                                                : "" || this.filterType == 6
                                                    ? "Error"
                                                    : "" || this.filterType == 7
                                                        ? "Terminate"
                                                        : "" || this.filterType == 8
                                                            ? "AdverseDrugEvent"
                                                            : "" || this.filterType == 9
                                                                ? "FormSusar"
                                                                : "",
                    });
                    i++;
                });
                this.isLoading = false;
            }).catch((e) => {
                console.log(e);
                this.isLoading = false;
            });
        },
        checkLink() {
            if (this.filterType === "1") {
                return "ViewFormRF12";
            }
            if (this.filterType === "2") {
                return "ViewFormRF04_2";
            }
            if (this.filterType === "3") {
                return "ViewFormRF05";
            }
            if (this.filterType === "4") {
                return "ViewFormRF03";
            }
            if (this.filterType === "5") {
                return "ViewFormRF06";
            }
            if (this.filterType === "7") {
                return "ViewFormRF07";
            }
            if (this.filterType === "8") {
                return "ViewFormRF04_1";
            }
            if (this.filterType === "9") {
                return "FormRFSusar";
            }
        },
        checkRadio(name) {
            if (name === "1") {
                this.checkRadio1 = true;
                this.checkRadio2 = false;
                this.checkRadio3 = false;
                this.checkRadio4 = false;
                this.checkRadio5 = false;
                this.checkRadio6 = false;
                this.checkRadio7 = false;
                this.checkRadio8 = false;
                this.checkRadio9 = false;
            }
            if (name === "2") {
                this.checkRadio1 = false;
                this.checkRadio2 = true;
                this.checkRadio3 = false;
                this.checkRadio4 = false;
                this.checkRadio5 = false;
                this.checkRadio6 = false;
                this.checkRadio7 = false;
                this.checkRadio8 = false;
                this.checkRadio9 = false;
            }
            if (name === "3") {
                this.checkRadio1 = false;
                this.checkRadio2 = false;
                this.checkRadio3 = true;
                this.checkRadio4 = false;
                this.checkRadio5 = false;
                this.checkRadio6 = false;
                this.checkRadio7 = false;
                this.checkRadio8 = false;
                this.checkRadio9 = false;
            }
            if (name === "4") {
                this.checkRadio1 = false;
                this.checkRadio2 = false;
                this.checkRadio3 = false;
                this.checkRadio4 = true;
                this.checkRadio5 = false;
                this.checkRadio6 = false;
                this.checkRadio7 = false;
                this.checkRadio8 = false;
                this.checkRadio9 = false;
            }
            if (name === "5") {
                this.checkRadio1 = false;
                this.checkRadio2 = false;
                this.checkRadio3 = false;
                this.checkRadio4 = false;
                this.checkRadio5 = true;
                this.checkRadio6 = false;
                this.checkRadio7 = false;
                this.checkRadio8 = false;
                this.checkRadio9 = false;
            }
            if (name === "6") {
                this.checkRadio1 = false;
                this.checkRadio2 = false;
                this.checkRadio3 = false;
                this.checkRadio4 = false;
                this.checkRadio5 = false;
                this.checkRadio6 = true;
                this.checkRadio7 = false;
                this.checkRadio8 = false;
                this.checkRadio9 = false;
            }
            if (name === "7") {
                this.checkRadio1 = false;
                this.checkRadio2 = false;
                this.checkRadio3 = false;
                this.checkRadio4 = false;
                this.checkRadio5 = false;
                this.checkRadio6 = false;
                this.checkRadio7 = true;
                this.checkRadio8 = false;
                this.checkRadio9 = false;
            }
            if (name === "8") {
                this.checkRadio1 = false;
                this.checkRadio2 = false;
                this.checkRadio3 = false;
                this.checkRadio4 = false;
                this.checkRadio5 = false;
                this.checkRadio6 = false;
                this.checkRadio7 = false;
                this.checkRadio8 = true;
                this.checkRadio9 = false;
            }
            if (name === "9") {
                this.checkRadio1 = false;
                this.checkRadio2 = false;
                this.checkRadio3 = false;
                this.checkRadio4 = false;
                this.checkRadio5 = false;
                this.checkRadio6 = false;
                this.checkRadio7 = false;
                this.checkRadio8 = false;
                this.checkRadio9 = true;
            }
            this.getDocumentResearch(1);
        },
    }
}
</script>

<style lang="scss" scoped></style>